import { render } from "./ZhaiThreeTuttonsPC.vue?vue&type=template&id=96ec8024&scoped=true"
import script from "./ZhaiThreeTuttonsPC.vue?vue&type=script&lang=js"
export * from "./ZhaiThreeTuttonsPC.vue?vue&type=script&lang=js"

import "./ZhaiThreeTuttonsPC.vue?vue&type=style&index=0&id=96ec8024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ec8024"]])

export default __exports__